import axios from "utils/axios";

export const REMITTANCE_DATA_ROUTE = `${process.env.REACT_APP_API_DOMAIN}/api/v1/contractor-invoice`;

export const getAllRemittanceData = (params) =>
  axios.post(`${REMITTANCE_DATA_ROUTE}/con-invoices`, params);